import Upload from 'antd/es/upload';
import message from 'antd/es/message';
import { t } from 'i18next';
import { ComponentProps } from 'react';
import UploadOutlined from '@ant-design/icons/UploadOutlined';

import { OpButton } from '../OpButton/OpButton';

interface OpUploadProps extends ComponentProps<typeof Upload> {
  testId?: string;
  buttonText?: string;
  maxFileSize?: number;
}

export const OpUpload = ({
  className = '',
  testId = 'op-upload',
  buttonText = t('Select file'),
  maxFileSize,
  children,
  beforeUpload,
  ...props
}: OpUploadProps) => {
  const finalChildren = children || (
    <OpButton className="op-upload__button" icon={<UploadOutlined />}>
      {buttonText}
    </OpButton>
  );

  const handleBeforeUpload = (file: File, fileList: File[]) => {
    // Check file size
    if (maxFileSize && file.size > maxFileSize) {
      const maxSizeMB = (maxFileSize / 1024 / 1024).toFixed(1);
      message.error({
        content: t('File size must be less than {{maxSize}}MB', {
          maxSize: maxSizeMB,
        }),
        duration: 3,
      });
      return false;
    }

    // Call custom beforeUpload if provided
    if (beforeUpload) {
      return beforeUpload(file as any, fileList as any);
    }

    return true;
  };

  return (
    <Upload
      data-testid={testId}
      className={`op-upload ${className}`.trim()}
      beforeUpload={handleBeforeUpload}
      {...props}
    >
      {finalChildren}
    </Upload>
  );
};
